export interface Testimonial {
  name: string
  role: string
  city: string
  quote: string[]
}

export const testimonials: Testimonial[] = [
  {
    name: 'Giulia Ferraro',
    role: 'Logopedista, 34 anni — studio privato',
    city: 'Bologna',
    quote: [
      'Seguo 22 pazienti a settimana e la parte più pesante non era la seduta: era tutto quello che veniva prima e dopo.',
      'Con LOGOPEDIA PRO™ apro il modulo delle sessioni, scelgo il percorso in base all’obiettivo e adatto due o tre passaggi. La preparazione del venerdì sera è passata da tre ore a poco più di trenta minuti.',
    ],
  },
  {
    name: 'Marta Bellini',
    role: 'Logopedista, 41 anni — età evolutiva',
    city: 'Torino',
    quote: [
      'Lavoro molto su fonologia e consapevolezza fonologica e avevo materiale sparso in decine di cartelle.',
      'Qui le attività sono già organizzate per obiettivo, con livello di difficoltà e progressione: seleziono, stampo e la seduta è pronta. Le schede di monitoraggio mi hanno anche semplificato la comunicazione con le famiglie.',
    ],
  },
  {
    name: 'Chiara D’Amico',
    role: 'Logopedista, 29 anni — centro di riabilitazione',
    city: 'Napoli',
    quote: [
      'Da neolaureata con esperienza in centro, la mia difficoltà era mantenere continuità tra una seduta e l’altra.',
      'I percorsi terapeutici e i criteri per avanzare o modificare un obiettivo mi hanno dato una struttura chiara. Ora ogni seduta è collegata alla successiva e non improvviso più.',
    ],
  },
  {
    name: 'Elena Rossi',
    role: 'Logopedista, 47 anni — adulti e neurologia',
    city: 'Padova',
    quote: [
      'Temevo fosse la solita raccolta di schede per bambini. Invece la parte di valutazione, documentazione e revisione del caso è utilissima anche con i miei pazienti adulti.',
      'Uso ogni settimana le note strutturate e il protocollo di revisione: preparo le relazioni in una frazione del tempo che impiegavo prima.',
    ],
  },
  {
    name: 'Francesco Lombardi',
    role: 'Logopedista, 38 anni — libero professionista',
    city: 'Palermo',
    quote: [
      'Il valore vero per me è il toolkit di adattamento: quando un paziente non risponde come previsto, ho già le opzioni per aumentare o ridurre la difficoltà senza perdere l’obiettivo.',
      'A 27€ ho recuperato l’investimento nella prima settimana, semplicemente in ore di preparazione che non ho più fatto.',
    ],
  },
]
